var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.cookieNotice'] = (function () {
    'use strict';

    const CONFIG = {
        CONFIRM_BTN_SELECTOR: "[data-cookienotice='confirm']",
        COOKIE_NAME: "MauiCountyFCU_CookieNotice",
        COOKIE_VALUE: "Confirmed",
        ANIMATION_DURATION: "250ms"
    };

    const initialize = (component) => {
        const confirmButton = component.querySelector(CONFIG.CONFIRM_BTN_SELECTOR);
        if (confirmButton) {
            confirmButton.addEventListener("click", () => {
                App.Cookies.setItem(CONFIG.COOKIE_NAME, CONFIG.COOKIE_VALUE, Infinity, "/", window.location.hostname, window.location.protocol === "https:");
                animate(component);
            });
        }
    };

    const animate = (component) => {
        component.addEventListener("transitionend", (e) => {
            if (e.propertyName === "transform") {
                component.remove();
            }
        });
        const animationDistance = component.offsetHeight;
        component.style.transition = `transform ${CONFIG.ANIMATION_DURATION} ease-in-out`;
        component.style.transform = `translateY(${animationDistance}px)`;
    };

    return {
        initialize
    };

})();
